<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle">
        사용 언어 순서 설정
      </h2>
      <draggable
        v-model="languageOrder"
        animation="300"
        class="languageOrder">
        <div
          v-for="(lang, index) in languageOrder"
          :key="index"
          class="langItem">
          {{ lang.n }}
        </div>
      </draggable>
      <div class="btns">
        <button type="button" class="btn btnPrimary" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'SetLanguageOrder',
  props: [
    'locale'
  ],
  components: {
    draggable
  },
  computed: {
    settings () {
      const settings = this.$store.getters['setting/getData']
      const langSettings = settings?.lang
      return langSettings
    },
    defaultLang () {
      return this.settings?.default
    },
    langOrder () {
      // 저장되어 있던 언어 순서 설정값
      const settings = this.settings
      const order = settings?.langOrder
      return order || []
    },
    list () {
      // 현재 사용중인 언어 리스트
      const settings = this.settings
      const listAll = settings?.info
      return listAll?.filter(item => item.u)
    },
    orderedLangCodes () {
      return this.languageOrder.map(x => x.c)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.list) {
        this.languageOrder = this.getSortedLanguages(this.list, this.langOrder, this.defaultLang)
      }
    })
  },
  data () {
    return {
      languageOrder: []
    }
  },
  methods: {
    getSortedLanguages (langList, langOrder, defaultLangCode) {
      // 1. 사용 언어 리스트
      const usedLangs = langList
      const langMap = new Map(usedLangs.map(lang => [lang.c, lang]));
      const sorted = [];

      // 1. 순서정보에 포함된 언어부터 추가
      for (const code of langOrder) {
        if (langMap.has(code)) {
          sorted.push(langMap.get(code));
          langMap.delete(code);
        }
      }

      // 2. 나머지 사용 언어 분리 및 정렬
      const remaining = Array.from(langMap.values());

      const translated = remaining.filter(lang => lang.t).sort((a, b) => a.c.localeCompare(b.c));
      const notTranslated = remaining.filter(lang => !lang.t).sort((a, b) => a.c.localeCompare(b.c));

      return [...sorted, ...translated, ...notTranslated];
    },
    apply () {
      this.$store.commit('setting/setLangOrder', this.orderedLangCodes)
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.languageOrder {
  .langItem {
    padding: 12px 16px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background-color: $color-white;
    cursor: move;
    & + .langItem {
      margin-top: 2px;
    }
  }
}
</style>